import "./SingleProductTemplate.module.css";
import Header from "@/reusable_sections/Header";
import SingleProduct from "./sections/SingleProduct";
import Footer from "@/reusable_sections/Footer";

export default function SingleProductTemplate() {
  return (
    <div>
      <Header />
      <SingleProduct />
      <Footer />
    </div>
  );
}
